import cx from 'classnames'
import { FC, useMemo } from 'react'
import { RichTextProps } from 'src/components/RichText'
import { motionGroup, separatorReveal, slideReveal } from 'src/hooks/useAppear'
import { MotionWrapper, SeparatorAbsolute } from 'src/theme/styled'

import * as SC from './styled'

export type EditoIntroProps = MinimalSeoBlock & {
  className?: string
  title?: string
  richTextProps?: RichTextProps
  isSecondary?: boolean
}

const EditoIntro: FC<EditoIntroProps> = ({
  className,
  title,
  richTextProps,
  htmlTag,
  htmlTitleTag,
  isSecondary,
}) => {
  const { motions, variants } = useEditoIntroMotion()

  return (
    <SC.Container
      as={htmlTag}
      className={cx('EditoIntro', className)}
      {...motions.container}
    >
      <SeparatorAbsolute
        aria-hidden
        role="separator"
        variants={variants.separator}
      />
      {title && (
        <SC.Title as={htmlTitleTag}>
          <MotionWrapper variants={variants.title}>{title}</MotionWrapper>
        </SC.Title>
      )}
      {richTextProps && (
        <SC._MotionMask>
          <MotionWrapper variants={variants.title}>
            <SC._RichText {...richTextProps} $isSecondary={isSecondary} />
          </MotionWrapper>
        </SC._MotionMask>
      )}
    </SC.Container>
  )
}

const useEditoIntroMotion = () => {
  const motions = useMemo(
    () => ({
      container: motionGroup({}).motionProps,
    }),
    []
  )

  const variants = useMemo(
    () => ({
      separator: separatorReveal({}),
      title: slideReveal({ y: '100%' }),
      text: slideReveal({ y: '100%', delay: 0.2 }),
    }),
    []
  )

  return { motions, variants }
}

export default EditoIntro
